import { createAction } from 'redux-actions';

export const actionTypes = {
    GET_LIST: 'appManagement/GET_LIST',
    GET_DETAIL: 'appManagement/GET_DETAIL',
    CREATE: 'appManagement/CREATE',
    UPDATE: 'appManagement/UPDATE',
    UPDATE_STATUS: 'appManagement/UPDATE_STATUS',
    RENEW_CLIENT_APP_ID: 'appManagement/RENEW_CLIENT_APP_ID',
    RENEW_SECRET_KEY: 'appManagement/RENEW_SECRET_KEY',
}

export const actions = {
    getList: createAction(actionTypes.GET_LIST),
    getDetail: createAction(actionTypes.GET_DETAIL),
    create: createAction(actionTypes.CREATE),
    update: createAction(actionTypes.UPDATE),
    updateStatus: createAction(actionTypes.UPDATE_STATUS),
    renewClientAppId: createAction(actionTypes.RENEW_CLIENT_APP_ID),
    renewSecretKey: createAction(actionTypes.RENEW_SECRET_KEY),
}

